import { IStore } from "services/indexdb/interface/istore"

export const QuerySettingsStore: IStore = {
    Name: 'QuerySettings',
    PrimaryField: 'id',
    minimumVersion: 0
}
